// extracted by mini-css-extract-plugin
export default {"privacy-policy-page":"privacy-policy_privacy-policy-page__BO92v","title":"privacy-policy_title__2nYbF"};